declare class Error {
  public code: number;
  public text: string;
  public name: string;
  constructor(message?: string);
}

class RequestError extends Error {
  constructor(code: number, text: string) {
    super(text);

    this.name = "RequestError";
    this.code = code;
    this.text = text;
  }
}

export default RequestError;
